import { CONTENT_REVERSE_DIRECTIONS } from '@v4/utils/data/PageMetaData'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Content.styled'

export const useContent = props => {
	const {
		text,
		textConfig,
		video,
		extraShortcuts,
		textEditable,
		onTextClick,
		onTextChange,
		textKey,
		videoPosition,
	} = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const classes = useStyles(props)

	return [
		{
			classes,
			isMobile,
			direction: isMobile ? CONTENT_REVERSE_DIRECTIONS[videoPosition] : null,
			text,
			textConfig,
			video,
			extraShortcuts,
			textEditable,
			textKey,
		},
		{ handleTextClick: onTextClick, handleTextChange: onTextChange },
	]
}
